export default {"src":"/_next/static/media/twitter.e59045ec.svg","height":271,"width":300,"blurWidth":0,"blurHeight":0};